import React from 'react'
import { effectiveLocation, getFormattedDate } from '../../../helpers/utils'
import { Table } from 'react-bootstrap'

const AssetDetailsTab = ({ activity, transactionUuid }) => {
    return (
        <div className="container-fluid">
            <div className="row">
                {transactionUuid && (
                    <>
                        <div className="row show-product-header">
                            <div className="col-sm-6">
                                <h3 className="margin-text-subtitle">Detalles del activo:</h3>
                            </div>
                        </div>
                        <hr />
                    </>
                )}

                <div>
                    <div className="show-product-header-ubiqua-app show-header">
                        <div>
                            <div className="order-client-name">{activity?.client_name}</div>
                            <div className="order-client-db_ref">Código: {activity?.client_uid}</div>
                        </div>
                    </div>
                    <hr />

                    <div>

                        <table cellSpacing="10">
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="mr-85 mb-10">
                                            <b>Fecha de creación:</b>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="mb-10">
                                            {getFormattedDate(activity?.report_date) || "-"}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="mr-85 mb-10">
                                            <b>Fecha de ejecución:</b>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="mb-10">
                                            {getFormattedDate(activity?.report_date) || "-"}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="mr-85 mb-10">
                                            <b>Número de reporte:</b>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="mb-10">{activity?.uid || "-"} </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="mr-85 mb-10">
                                            <b>Usuario:</b>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="mb-10">{`${activity?.user_uid} - ${activity?.user_full_name}` || "-"}</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="mr-85 mb-10">
                                            <b>Dentro de geocerca:</b>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="mb-10">{effectiveLocation(activity?.effective_location) || "-"}</div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <hr />
                        <div className="show-data-details">
                            <div>
                                <b>Activos:</b>
                            </div>
                        </div>
                        <Table hover responsive>
                            <thead className="table-header-gray">
                                <tr>
                                    <th># DE ACTIVO	</th>
                                    <th>NOMBRE ACTIVO</th>
                                    <th>ENTREGADO</th>
                                    <th>RECIBIDO</th>
                                    <th>TOTAL</th>
                                </tr>
                            </thead>
                            <tbody>
                                {activity?.asset_details?.map((model, index) => (
                                    <tr key={index}>
                                        <td>{model.assetUid}</td>
                                        <td>{model.assetTitle || "-"}</td>
                                        <td>{model.delivered || "-"}</td>
                                        <td>{model.received || "-"}</td>
                                        <td>{model.total || "-"}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AssetDetailsTab